export enum AkaTravelInsuranceType {
  AKA_TRAVEL_SUPER = "akaTravelSuper",
  AKA_TRAVEL_STANDARD = "akaTravelStandard",
}
